import React from 'react';
import { Route } from 'react-router-dom';
import ErrorBoundary from 'components/ErrorBoundary';
import __ from 'localisation';
import SkipToContentLink from 'components/SkipToContentLink';
import Main, { MainTitle } from 'components/Main';
import Wrapper from '@hubins/components/Wrapper';
import PageFooter from 'components/PageFooter';
import BackofficeSidebar from '@backoffice/components/BackofficeSidebar';
import { useAuth } from '../../contexts/AuthContext';


import './LayoutDefault.scss';

const LayoutDefault = (props) => {
  const { user, userRoles } = useAuth();
  const name = user?.name || '';
  const contact_type = user?.roles?.[0]?.name;

  return (
    // <>
    //   <SkipToContentLink
    //     target="MainContent"
    //     text={__('skip_to_main_content')}
    //   />
    //   <ErrorBoundary>
    //     <LoggedinMenuQLCrm path={props.path} logo={Logo} />
    //   </ErrorBoundary>
    //   <ErrorBoundary>
    //     <Main noSpace className="relative">
    //       <Wrapper rounded stretch tight className="backoffice-wrapper">
    //         {props.title && (
    //           <MainTitle className="c-primary" title={props.title} />
    //         )}
    //         <Route {...props} />
    //       </Wrapper>
    //     </Main>
    //   </ErrorBoundary>
    //   <PageFooter />
    // </>
    <>
      <SkipToContentLink
        target="MainContent"
        text={__('skip_to_main_content')}
      />
      <ErrorBoundary>
        <div className="side-menu-layout">
          <BackofficeSidebar
            {...props}
            name={name}
            userRoles={userRoles}
            contact_type={contact_type}
          />
          <div className="layout_default__main">
            <Main noSpace className="relative">
              <Wrapper stretch tight className="backoffice-wrapper">
                {props.title && (
                  <MainTitle className="c-primary" title={props.title} />
                )}
                <Route {...props} />
              </Wrapper>
            </Main>
            <PageFooter />
          </div>
        </div>
      </ErrorBoundary>
    </>
  );

};

export default LayoutDefault;
